import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Tooltip, Typography, Autocomplete } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { NotificationManager } from 'react-notifications';
import Toggle from 'react-toggle';
import { NOT_REQUIRED, REQUIRED, DEFAULT_RADNOM_SUBCATEGORY_ORDER, SFMessageType } from '../Constants';
import { BsInfoCircleFill } from 'react-icons/bs';
import ApiRequestService from '../../../component/ApiRequestService';
import SFMessage from '../components/SFMessage';

const CategoryOptionsModal = ({
    showModal,
    handleClose,
    onSaveCategoryOption,
    assignment,
    categoriesArr,
    fcCount,
    isTutorial
}) => {

    const [categories, setCategories] = useState(categoriesArr ? categoriesArr : [])
    const [freeChoiceCount, setFreeChoiceCount] = useState(fcCount);
    const [tutorials, setTutorials] = useState([]);
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState(SFMessageType.INFO);
    const [requiredCount, setRequiredCount] = useState(categories.length ?? 0);
    const [notRequiredCount, setNotRequiredCount] = useState(0);

    useEffect(() => {

        let notRequiredCount = 0;
        let requiredCount = 0

        categories.forEach(cat => {
            if (cat.required === REQUIRED) {
                requiredCount += 1;
            } else {
                notRequiredCount += 1;
            }
        });

        setRequiredCount(requiredCount);
        setNotRequiredCount(notRequiredCount);
        if (notRequiredCount === 0) {
            setFreeChoiceCount(0);
        }

    }, [categories]);

    useEffect(() => {
        // getAllTutorials();
    }, []);

    const getAllTutorials = () => {
        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/getTutorials',
        }).then(res => {
            if (res && res.data && res.data.data) {
                setTutorials(res.data.data.map(tut => {
                    return {
                        id: tut.quiz_id,
                        label: tut.quiz_name,
                    }
                }));
            } else {
                setTutorials([]);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        if (notRequiredCount === 0) return;

        if (requiredCount === 0 && freeChoiceCount <= 0) {
            setMessageType(SFMessageType.ERROR);
            return
        }

        if (requiredCount > 0 && freeChoiceCount > 0 && freeChoiceCount > notRequiredCount ) {
            setMessageType(SFMessageType.ERROR);
            return
        }

        setMessageType(SFMessageType.INFO);
        
    }, [freeChoiceCount, requiredCount, notRequiredCount])

    const handleSave = () => {
        let notRequiredCount = 0;
        let requiredCount = 0

        categories.forEach(cat => {
            if (cat.required === REQUIRED) {
                requiredCount += 1;
            } else {
                notRequiredCount += 1;
            }
        });

        console.debug("freeChoiceCount", freeChoiceCount, notRequiredCount)
        if (freeChoiceCount > notRequiredCount) {
            NotificationManager.error('Minimum number of Free Choice Categories required to be completed should not be greater than the total number of optional categories in this assignment');
            return;
        }

        if (freeChoiceCount < 1 && notRequiredCount === categories.length) {
            NotificationManager.error('Since you have only optional cateories in this assignment, the Minimum number of Free Choice Categories required to be completed should be greater than 0');
            return;
        }

        onSaveCategoryOption(categories, freeChoiceCount);
    }

    return (
        <Dialog
            open={showModal}
            fullWidth
            maxWidth={false}
            // maxWidth="lg"
            PaperProps={{
                sx: {
                    // minHeight: 600
                    width: 'auto'
                }
            }}
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={600}>
                    Category Options
                </Typography>
            </DialogTitle>
            {/* <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton> */}

            <DialogContent>
                <div style={{ marginBottom: "8px" }}>
                    <SFMessage
                        show={notRequiredCount > 0}
                        type={messageType}
                        title={"Free choice category"}
                        description={
                            <div
                            // style={{display:"flex", justifyContent:'flex-start', alignItems:'flex-start'}}
                            >
                                <div>Minimum number of Free Choice Categories to be completed (in addition to the required categories)</div>
                                <TextField
                                    sx={{
                                        width: "70px",
                                        marginTop: '4px',
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: '#fff',
                                        }
                                    }}
                                    value={freeChoiceCount}
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        // if any 1 category is marked required then zero is allowed
                                        let hasOneRequired = categories.some(cat => cat.required === REQUIRED)
                                        if (hasOneRequired === false) {
                                            if (value <= 0) {
                                                NotificationManager.error("Zero is not allowed because all categories are marked as not required.");
                                                value = 1;
                                            }
                                        } else {
                                            if (value < 0) value = 0;
                                        }

                                        let notRequiredCount = 0;
                                        let requiredCount = 0

                                        categories.forEach(cat => {
                                            if (cat.required === REQUIRED) {
                                                requiredCount += 1;
                                            } else {
                                                notRequiredCount += 1;
                                            }
                                        });
                                        if (value > notRequiredCount) {
                                            NotificationManager.error("Minimum number of Free Choice Categories required to be completed should not be greater than the total number of optional categories in this assignment");
                                            return;
                                        }

                                        setFreeChoiceCount(value);
                                    }}
                                    size='small'
                                    type='number'
                                />
                            </div>
                        }
                    />
                </div>
               {/*  {notRequiredCount > 0 ?
                    <div style={{
                        marginBottom: "8px"
                    }}>
                        <div>
                            Minimum number of Free Choice Categories to be completed
                        </div>
                        <div>
                            (in addition to the required categories)
                            <TextField
                                sx={{
                                    width: "70px",
                                    marginLeft: "4px",
                                }}
                                value={freeChoiceCount}
                                onChange={e => {
                                    let value = parseInt(e.target.value);
                                    if (value <= 0) value = 1;
                                    setFreeChoiceCount(value);
                                }}
                                size='small'
                                type='number'
                            />
                        </div>
                    </div>
                    : null} */}
                <div className='matrix-table-container category-option-table'>


                    <table className="matrix-table">
                        <thead className='matrix-table-head'>
                            <tr className="matrix-row-header">
                                <th className="matrix-row-cell" style={{ minWidth: "150px" }}>Subject</th>
                                <th className="matrix-row-cell" style={{ minWidth: "150px" }}>Topic</th>
                                <th className="matrix-row-cell category-width">Categories</th>

                                {/* {isTutorial === null || isTutorial === undefined || isTutorial === false ?
                                    <th className="matrix-row-cell" style={{
                                        minWidth: '200px'
                                    }}>
                                        Tutorials
                                    </th>
                                    : null} */}

                                <th
                                    key={0}
                                    className="matrix-row-cell"
                                    style={{
                                        minWidth: "100px",
                                    }}
                                >
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            NOCQC
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Mastery Condition
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "180px",
                                    }}>
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            # of Questions
                                            <Tooltip
                                                arrow
                                                title={
                                                    <Typography
                                                        className='text-white' fontSize={14}>
                                                        Indicate number of questions to be randomly chosen from the category (chosen according to subcategory weights). If left blank then all questions in the category will be presented.
                                                    </Typography>
                                                }>
                                                <span style={{ marginLeft: "6px" }}>
                                                    <BsInfoCircleFill color='#737373' size={14}
                                                        style={{
                                                            flexShrink: 0,
                                                            minWidth: "12px",
                                                            minHeight: "12px",
                                                            verticalAlign: "middle",
                                                            cursor: "pointer",
                                                        }} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            NOCQC
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "160px",
                                    }}>
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            # of Available Questions
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Random Subcategory Order
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "150px",
                                    }}>
                                    {assignment?.quiz_type === 1 ?
                                        <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Random Subcategory Order
                                        </div>
                                        : <div className='category-header-tag cat-cell' onClick={() => { }}>
                                            Required
                                        </div>
                                    }
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "100px",
                                    }}>
                                    <div className='category-header-tag cat-cell' onClick={() => { }}>
                                        At First
                                    </div>
                                </th>
                                <th className="matrix-row-cell"
                                    style={{
                                        minWidth: "100px",
                                    }}>
                                    <div className='category-header-tag cat-cell' onClick={() => { }}>
                                        At Last
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((category, index) => {
                                return (
                                    <tr className="matrix-row" key={index}>
                                        <td className="matrix-row-cell" style={{ textAlign: 'left' }}>
                                            <div className='category-name-cell'>
                                                <div className='category-name'>
                                                    {category.subject_name}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="matrix-row-cell" style={{ textAlign: 'left' }}>
                                            <div className='category-name-cell'>
                                                <div className='category-name'>
                                                    {category.topic_name}
                                                </div>
                                            </div>
                                        </td>
                                        <td className="matrix-row-cell category-width" style={{ textAlign: 'left' }}>
                                            <div className='category-name-cell'>
                                                <div className='category-name'>
                                                    {category.category_name || category.category_Name}
                                                </div>
                                            </div>
                                        </td>

                                        {/* {isTutorial === null || isTutorial === undefined || isTutorial === false ?
                                            <td className="matrix-row-cell" style={{ textAlign: 'left' }}>
                                                <div className='category-name'>
                                                    <Autocomplete
                                                        disablePortal
                                                        size='small'
                                                        options={tutorials}
                                                        multiple
                                                        filterSelectedOptions
                                                        // value={null}
                                                        onChange={() => { }}
                                                        getOptionLabel={(option) => option?.label}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Select Tutorials"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    sx: {
                                                                        borderRadius: "6px",
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </td>
                                            : null} */}

                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ?
                                                <TextField size='small' type="number" sx={{ width: "50px" }} value={parseInt(category.nocqc)}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);
                                                        if (updatedValue <= 0) updatedValue = 1;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].nocqc = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                                :
                                                <TextField size='small' type="number" sx={{ width: "50px" }}
                                                    value={parseInt(category.masteryCount)}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);
                                                        if (updatedValue <= 0) updatedValue = 1;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].masteryCount = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ?
                                                <TextField size='small' type="number" sx={{ width: "50px" }}
                                                    value={parseInt(category.noOfQuestion) !== 0 ? parseInt(category.noOfQuestion) : null}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);
                                                        if (updatedValue <= 0) updatedValue = category.question_count;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].noOfQuestion = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                                :
                                                <TextField size='small' type="number" sx={{ width: "50px" }} value={parseInt(category.nocqc)}
                                                    onChange={e => {
                                                        let updatedValue = parseInt(e.target.value);
                                                        if (updatedValue <= 0) updatedValue = 1;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].nocqc = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ? category.question_count :
                                                <Toggle checked={category.randomSubcategoryOrder === DEFAULT_RADNOM_SUBCATEGORY_ORDER} icons={false} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = category.randomSubcategoryOrder === DEFAULT_RADNOM_SUBCATEGORY_ORDER ? 2 : DEFAULT_RADNOM_SUBCATEGORY_ORDER;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].randomSubcategoryOrder = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            {assignment?.quiz_type === 1 ?
                                                <Toggle checked={category.randomSubcategoryOrder === DEFAULT_RADNOM_SUBCATEGORY_ORDER} icons={false} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = category.randomSubcategoryOrder === DEFAULT_RADNOM_SUBCATEGORY_ORDER ? 2 : DEFAULT_RADNOM_SUBCATEGORY_ORDER;
                                                        let updatedCategories = [...categories];
                                                        updatedCategories[index].randomSubcategoryOrder = updatedValue;
                                                        setCategories(updatedCategories)
                                                    }}
                                                />

                                                :
                                                <Toggle checked={category.required === REQUIRED} icons={false} className='custom-react-toggle'
                                                    onChange={() => {
                                                        let updatedValue = category.required === REQUIRED ? NOT_REQUIRED : REQUIRED;
                                                        let updatedCategories = [...categories];
                                                        if (updatedValue === NOT_REQUIRED) {
                                                            updatedCategories[index].atFirst = 0;
                                                            updatedCategories[index].atLast = 0;
                                                        }
                                                        updatedCategories[index].required = updatedValue;

                                                        setCategories(updatedCategories)
                                                    }}
                                                />
                                            }
                                        </td>
                                        <td className="matrix-row-cell">
                                            <Toggle checked={category.atFirst === 1} icons={false} className='custom-react-toggle'
                                                onChange={() => {
                                                    let updatedValue = category.atFirst === 1 ? 0 : 1;
                                                    let updatedCategories = [...categories];
                                                    if (updatedValue == 1) {
                                                        for (let i = 0; i < updatedCategories.length; i++) {
                                                            updatedCategories[i].atFirst = 0;
                                                            // updatedCategories[i].atLast = 0;
                                                        }
                                                        updatedCategories[index].required = 1;
                                                        updatedCategories[index].atLast = 0;
                                                    }

                                                    updatedCategories[index].atFirst = updatedValue;

                                                    if (updatedValue === 1) {
                                                        let temp = updatedCategories[0];
                                                        updatedCategories[0] = updatedCategories[index];
                                                        updatedCategories[index] = temp
                                                    }

                                                    setCategories(updatedCategories)
                                                }}
                                            />
                                        </td>
                                        <td className="matrix-row-cell">
                                            <Toggle checked={category.atLast === 1} icons={false} className='custom-react-toggle'
                                                onChange={() => {
                                                    let updatedValue = category.atLast === 1 ? 0 : 1;
                                                    let updatedCategories = [...categories];
                                                    if (updatedValue == 1) {
                                                        for (let i = 0; i < updatedCategories.length; i++) {
                                                            // updatedCategories[i].atFirst = 0;
                                                            updatedCategories[i].atLast = 0;
                                                        }
                                                        updatedCategories[index].required = 1;
                                                        updatedCategories[index].atFirst = 0;
                                                    }
                                                    updatedCategories[index].atLast = updatedValue;

                                                    if (updatedValue === 1) {
                                                        let l = updatedCategories.length;
                                                        let temp = updatedCategories[l - 1];
                                                        updatedCategories[l - 1] = updatedCategories[index];
                                                        updatedCategories[index] = temp
                                                    }

                                                    setCategories(updatedCategories)
                                                }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </DialogContent>
            <DialogActions>
                {/* <Button variant='outlined' onClick={handleClose}>
                    Cancel
                </Button> */}
                <Button variant='contained' onClick={handleSave}
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog >
    );
}

export default CategoryOptionsModal;
